var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('lm-icon-button',{staticClass:"LmStateButtonMini",attrs:{"label":_vm.label,"icon":_vm.icon,"highlight":_vm.selected,"tooltip":_vm.tooltip,"compacted":"","svg":""},on:{"click":function($event){return _vm.$emit('click', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }